import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreatePayoutRequestSchema,
  TCreatePayoutResponseSchema,
} from "./createPayout.schema";

export const createPayout = (axios: IAxiosInstance) => {
  return async (body: TCreatePayoutRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreatePayoutResponseSchema>
    >(`/api/charges-and-fees/payouts`, body);

    return response.data;
  };
};
